import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type HelpTextService from '../services/help-text';
import type { htmlSafe } from '@ember/template';
type SafeString = ReturnType<typeof htmlSafe>;

export default class HelptextHelper extends Helper {
  @service('help-text') declare helptext: HelpTextService;
  @service declare intl: IntlService;
  @service('aditools-site') declare siteconfig: { [key: string]: string }; //SiteService;

  async compute(params: string[], hash: Record<string, unknown>): Promise<string | SafeString> {
    let text = await this.helptext.helpText(params[0] as string);
    let keyParms: Record<string, string | number | boolean> = { htmlSafe: true };
    if (text.indexOf('{siteurl}') > -1) {
      keyParms['siteurl'] = this.siteconfig['SiteUrl'] + '/' + this.siteconfig['AdiLocale'];
    }
    //await new Promise((res) => setTimeout(res, 2000));  // For testing visual presentation of simulated load delay locally
    return this.intl.formatMessage(this.helptext.toICUMessage(text), Object.assign(keyParms, hash));
  }
}
